module.exports = __webpack_public_path__ + "img/budgit.69b8a31d.svg";